import { apiClient } from '@/app/api/client';

export interface TenantDto {
  id: string;
  name: string;
  subscription_status: 'trialing' | 'active' | 'past_due' | 'canceled';
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  created_at: number;
  users: string;
  settings: string; // JSON string
}

export interface UpdateTenantRequest {
  name: string;
  subscription_status: 'trialing' | 'active' | 'past_due' | 'canceled';
  settings: string;
}

export const tenantsApi = {
  async cancelSubscription(id: string): Promise<{ success: boolean }> {
    const { data } = await apiClient.post(`/api/admin/tenants/${id}/cancel-subscription`);
    return data;
  },
  async deleteTenant(id: string): Promise<{ success: boolean }> {
    const { data } = await apiClient.delete(`/api/admin/tenants/${id}`);
    return data;
  },
  async getTenants(): Promise<TenantDto[]> {
    const { data } = await apiClient.get('/api/admin/tenants');
    return data;
  },

  async updateTenant(id: string, request: UpdateTenantRequest): Promise<TenantDto> {
    const { data } = await apiClient.put(`/api/admin/tenants/${id}`, request);
    return data;
  },
};

export function useTenantsService() {
  return tenantsApi;
}
